<!-- 
  Corrigir tamanho texto/imagem
  Incorporar antigas páginas de Tecnologia, Escola e Família
  -->
<template>
  <section>
    <Banner value="Atividades Extracurriculares" />
    <hr style="border:5px solid #DDD" />

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex xs12>
            <p class="lead">{{ wrapper.description }}</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none;">
      <v-container grid-list-xl>
        <v-layout row wrap>
          <v-flex
            xs6
            sm6
            md4
            v-for="atividade in wrapper.activities"
            :key="atividade.id"
          >
            <img
              :src="atividade.avatar ? atividade.avatar : '/images/400x300.jpg'"
              alt="Foto"
              style="width:100%"
            />
            <h2 class="title">{{ atividade.title }}</h2>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import jsonData from "../../../public/api/v1/atividade/1.json";
var marked = require("marked");

class Table {
  constructor(datas) {
    this.numRows = 0;
    this.numCols = 0;
    this.lines = [];
    this._setNumRowsCols(datas);
    this._setLines(datas);
  }

  _getValue(datas, row, col) {
    let value = null;
    datas.forEach(function(data) {
      if (data.row === row && data.col === col) {
        value = data.value;
      }
    });
    return value;
  }

  _setNumRowsCols(datas) {
    let self = this;
    datas.forEach(function(data) {
      data.row > self.numRows ? (self.numRows = data.row) : null;
      data.col > self.numCols ? (self.numCols = data.col) : null;
    });
    self.numRows++;
    self.numCols++;
  }

  _setLines(datas) {
    for (let row = 0; row < this.numRows; row++) {
      let line = [];
      for (let col = 0; col < this.numCols; col++) {
        line.push(this._getValue(datas, row, col));
      }
      this.lines.push(line);
    }
  }
}

export default {
  data: () => ({
    wrapper: [],
    table: null, // tabela convertida
    datas: [
      { row: 0, col: 0, value: "Heading 1" },
      { row: 0, col: 1, value: "Heading 2" },
      { row: 0, col: 2, value: "Heading 3" },
      { row: 1, col: 0, value: "Data 1.1" },
      { row: 1, col: 1, value: "Data 2.1" },
      { row: 1, col: 2, value: "Data 3.1" },
      { row: 2, col: 0, value: "Data 1.2" },
      { row: 2, col: 1, value: "Data 2.2" },
      { row: 2, col: 2, value: "Data 3.2" },
      { row: 3, col: 0, value: "Data 1.3" },
      { row: 3, col: 1, value: "Data 2.3" },
      { row: 3, col: 2, value: "Data 3.3" },
    ],
  }),
  created: function() {
    this.wrapper = jsonData;
  },
  methods: {
    compiledMarkdown: function(value) {
      if (value) {
        return marked(value, { sanitize: true });
      }
    },
    getTable(tableData) {
      return new Table(tableData);
    },
  },
  mounted: function() {
    this.table = new Table(this.datas);
  },
  components: {
    Banner,
  },
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
}

.img3d {
  width: 100%;
  transform: perspective(400px) rotateY(15deg);
  box-shadow: -5px 0px 10px #666;
}
</style>
